(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/views/play-package-page.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/views/play-package-page.js');

'use strict';

svs.keno.views.PlayPackagePage = Marionette.View.extend({
  viewOptions: ['size'],
  regions: {
    ngCampaignImageRegion: '#ngCampaignImageRegion',
    ngRowsContainerRegion: '#ngRowsContainerRegion',
    ngBetslipRegion: '#ngBetslipRegion',
    ngPayfooterRegion: '#ngPayfooterRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'keno',
    component: 'play'
  }],
  template(data) {
    return svs.keno.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.keno.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: svs.numbergames.productMapping.CONSTANTS.KENO,
        isPackage: true
      }, {
        storageKey: 'package',
        parse: true,
        hasTickets: svs.keno.data.hasTickets
      });
      model.setPackage(this.size);
      this.showChildView('ngCampaignImageRegion', new svs.numbergames.game.views.CampaignImage({
        model
      }));
      this.showChildView('ngRowsContainerRegion', new svs.keno.components.play.views.PackageRowsContainer({
        model
      }));
      this.showChildView('ngBetslipRegion', new svs.keno.components.play.views.Betslip({
        model
      }));
      this.showChildView('ngPayfooterRegion', new svs.keno.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);